export default {
  methods: {
    // 统一实名方法
    async toRealNameForAllPlatform(redirectUrl, orgId, autoRedirect = true) {
      return orgId
        ? await this.setOrganRealNameForAllPlatform(orgId, redirectUrl, autoRedirect)
        : this.setRealNameForAllPlatform(redirectUrl, autoRedirect)
    },

    // 获取个人实名
    async setRealNameForAllPlatform(redirectUrl = window.location.href, autoRedirect = true) {
      const { data } = await this.$EHttp.api({
        url: 'webserver/v1/accounts/identities/{accountId}/getIdentifyUrl',
        method: 'POST',
        params: {},
        body: {
          // notifyUrl: '',
          // showResultPage: '',
          // type: '',
          redirectUrl,
        },
      })

      if (autoRedirect) window.location.href = data.url

      return data.url
    },

    // 获取个人实名
    async setOrganRealNameForAllPlatform(orgId, redirectUrl = window.location.href, autoRedirect = true) {
      const { data } = await this.$EHttp.api({
        url: `webserver/v1/organizations/identities/${orgId}/getIdentifyUrl`,
        method: 'POST',
        params: {},
        body: {
          // notifyUrl: '',
          // showResultPage: '',
          // type: '',
          redirectUrl,
          agentAccountId: 'sys_accountId',
        },
      })

      if (autoRedirect) window.location.href = data.url

      return data.url
    },

    // 获取个人实名
    async setRealName(redirectUrl = window.location.href, autoRedirect = true) {
      const { data } = await this.$Http.api({
        url: 'webserver/user/accounts/realname',
        method: 'POST',
        params: {},
        body: {
          // notifyUrl: '',
          // showResultPage: '',
          // type: '',
          redirectUrl,
        },
      })

      if (autoRedirect) window.location.href = data.url

      return data.url
    },

    // 获取企业实名
    async setOrganRealName(orgId, redirectUrl = window.location.href, autoRedirect = true) {
      const { data } = await this.$Http.api({
        url: 'webserver/user/organizations/{orgId}/realname',
        method: 'POST',
        params: {
          orgId,
        },
        body: {
          // agentAccountId: '',
          // notifyUrl: '',
          // showResultPage: '',
          redirectUrl,
        },
      })

      if (autoRedirect) window.location.href = data.url

      return data.url
    },

    // 实名提醒 用处不多
    async realnameConfirm(message, redirectUrl, orgId) {
      const confirmFlag = await this.showRealnameWarn(message, orgId)

      if (!confirmFlag) return false

      await (orgId ? this.setOrganRealName(orgId, redirectUrl) : this.setRealName(redirectUrl))
    },

    showRealnameWarn(message, orgId) {
      const msg = message || (orgId ? '该企业还未进行实名认证, 请先认证。' : '您还未进行实名认证，请先认证。')

      return this.$dialog
        .confirm(msg, '温馨提示', {
          customClass: 'saas-confirm icon-top',
          distinguishCancelAndClose: true,
          confirmButtonText: '前往认证',
          cancelButtonText: '放弃',
          confirmButtonClass: 'btn-primary',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning',
        })
        .then(async () => true)
        .catch(() => false)
    },
  },
}
